import { renderDocumentBody } from './document-tokens';

export interface MessageTokenContact {
  firstName: string;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
}

export interface MessageTokenExtras {
  project?: { title: string; shootDate?: string | null } | null;
  studioName?: string | null;
  /** Injectable clock for deterministic tests; defaults to the real now. */
  now?: Date;
}

/** Merge variables available in message templates — shared doc token engine syntax. */
export const MESSAGE_TOKEN_KEYS = [
  'contact.firstName',
  'contact.fullName',
  'contact.phone',
  'contact.email',
  'project.title',
  'project.shootDate',
  'date.today',
  'date.tomorrow',
  'studio.name',
] as const;

const RU_DATE = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });

function ruDay(date: Date): string {
  return RU_DATE.format(date);
}

export function renderMessageTokens(body: string, contact?: MessageTokenContact | null, extras?: MessageTokenExtras): string {
  const now = extras?.now ?? new Date();
  const values = [
    { key: 'date.today', value: ruDay(now) },
    { key: 'date.tomorrow', value: ruDay(new Date(now.getTime() + 24 * 60 * 60 * 1000)) },
    { key: 'project.title', value: extras?.project?.title ?? '' },
    {
      key: 'project.shootDate',
      value: extras?.project?.shootDate ? ruDay(new Date(`${extras.project.shootDate}T12:00:00`)) : '',
    },
    { key: 'studio.name', value: extras?.studioName ?? '' },
  ];
  if (contact) {
    const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim();
    values.push(
      { key: 'contact.firstName', value: contact.firstName },
      { key: 'contact.fullName', value: fullName },
      { key: 'contact.phone', value: contact.phone ?? '' },
      { key: 'contact.email', value: contact.email ?? '' },
    );
  }

  const rendered = renderDocumentBody(body, values);
  // A known token with no value (no linked project, empty phone) is stripped, not sent as raw braces.
  const known = new Set<string>(MESSAGE_TOKEN_KEYS);
  return rendered.replace(/\{\{\s*([\w.-]+)\s*\}\}/g, (token, key: string) => (known.has(key) ? '' : token));
}
